// extracted by mini-css-extract-plugin
export default {"holdingsForm":"holdingsForm---ZT8Oo"};